import { FunctionComponent } from 'react';
import { useSetSearchNavigation } from 'components/search/useSetSearchNavigation';

/**
 * Wrapper for useSetSearchNavigationHook
 * sets navigation data for back button and title
 */
export const SearchNavigation: FunctionComponent = () => {
  useSetSearchNavigation();
  return null;
};
